import React from "react";
import Modal from "..";
import * as S from "./taskImgBackModal.style";
import { Button } from "../../../atoms/Buttons";
import { useNavigate } from "react-router";

type TaskImgBackModalType = {
  onModalCloseHanlder: () => void;
};

const TaskImgBackModal = ({ onModalCloseHanlder }: TaskImgBackModalType) => {
  const navigate = useNavigate();
  return (
    <Modal title="사진등록 취소" titlePosition="center" size="md">
      <S.TaskImgBackModalLayout>
        <p>
          현재 등록 중인 사진을 저장하지 않으셨습니다. 저장하지 않고 이전으로
          돌아가시겠습니까?
        </p>
        <S.TaskImgBackModalButtonBox>
          <div className="small">
            <Button
              type="button"
              size="full"
              color="transparent"
              label="취소"
              onClick={onModalCloseHanlder}
            />
          </div>
          <Button
            type="button"
            size="full"
            color="primary"
            label="확인"
            onClick={() => navigate(-1)}
          />
        </S.TaskImgBackModalButtonBox>
      </S.TaskImgBackModalLayout>
    </Modal>
  );
};

export default TaskImgBackModal;
